module.exports = __webpack_public_path__ + "media/img/help_center/Student_Test_05-a21db41fdd86e6e6bd4d5d2bd2517997.jpg";